var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { getFieldTitle } from "../../../redux/form/form.utils";
import * as S from "./FormSectionSubtitle.styles";
var FormSectionSubtitle = /** @class */ (function (_super) {
    __extends(FormSectionSubtitle, _super);
    function FormSectionSubtitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderContent = function () { return (_jsxs(_Fragment, { children: [_jsx(S.Title, { children: _this.props.title }), _this.props.onPressInfoIcon && _jsx(S.InfoIcon, {})] })); };
        return _this;
    }
    FormSectionSubtitle.prototype.render = function () {
        var onPressInfoIcon = this.props.onPressInfoIcon;
        if (onPressInfoIcon) {
            return (_jsx(S.WrapTouchable, { onPress: onPressInfoIcon, children: this.renderContent() }));
        }
        return _jsx(S.Wrap, { children: this.renderContent() });
    };
    return FormSectionSubtitle;
}(React.PureComponent));
var FormSectionSubtitleJsonFormSchema = /** @class */ (function (_super) {
    __extends(FormSectionSubtitleJsonFormSchema, _super);
    function FormSectionSubtitleJsonFormSchema() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSectionSubtitleJsonFormSchema.prototype.render = function () {
        var _a = this.props, uiSchema = _a.uiSchema, formContext = _a.formContext;
        return _jsx(FormSectionSubtitle, { title: getFieldTitle(uiSchema, formContext) });
    };
    return FormSectionSubtitleJsonFormSchema;
}(React.PureComponent));
export { FormSectionSubtitleJsonFormSchema };
// eslint-disable-next-line import/no-default-export
export default FormSectionSubtitle;
